<app-modal-window title="Подтвердите действие"
                  [actions]="true"
                  (close)="decline()"
                  (confirm)="accept()">
<!--  <p>Вы уверены, что хотите удалить: </p>-->
<!--  <p>id:{{data.id}} / <b> {{data.title}}</b></p>-->
</app-modal-window>
